import React, { useEffect, useState, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, isEqual, find, replace } from 'lodash'
//////COMPONENTS//////
import { initKioskCreationAddItemsActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import Table from '../../components/Table'
import Theme from '../../theme/theme'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import { uriList } from '../../routings/settings/RouteList'
import userPrivileges from '../../constants/PrivilegesList'
import Button from '../../components/Ui/Buttons'
import { KioskAddItemStatus, KioskAddItemImg } from './Components'
import UseCheckAll from '../../hooks/UseCheckAll'
import { PageWrapperLinks, TextModal } from '../../theme/GlobalCss'
import TooltipHelp from '../../components/TooltipHelp'
import Modals from '../../components/Modals'
import StringFormatter from '../../helpers/StringFormatter'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import ArrowWhiteRight from '../../assets/icones/global/arrow-white-right.svg'
import Add from '../../assets/icones/global/add.svg'
import Less from '../../assets/icones/global/hyphen.svg'
import view from '../../assets/icones/global/view.svg'
import Validation from '../../assets/icones/global/check.svg'

//////STYLED//////
const KioskAddItemWrapper = styled.div`
	position: relative;
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
const ButtonWrapperCustom = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: center;
	font-size: 13px;
`
//////STYLED//////

const KioskAddItem = () => {
	const {
		user,
		userRolePrivileges,
		translations,
		initKioskCreationStatus,
		initKioskCreationContent,
		initKioskCreation,
		initKioskCreationItems,
		initKioskCreationFilters,
		isUpdated,
		errorUnlink,
		isSearchfieldUpdated,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			userRolePrivileges: state.user.identity.rolePrivileges,
			userKioskPerimeter: state.user.identity.kioskSelected,
			initKioskCreationFilters: state.initKioskCreation?.addItems?.data?.headerParam?.filters,
			initKioskCreationItems: state.initKioskCreation.addItems,
			initKioskCreation: state.initKioskCreation,
			initKioskCreationContent: state.initKioskCreation?.addItems?.data?.headerContent?.contentPagined?.content,
			initKioskCreationStatus: state.initKioskCreation?.addItems?.data?.headerParam?.progressInfo,
			isUpdated: state.initKioskCreation.addItems.isUpdated,
			errorUnlink: state.initKioskCreation.addItems.errorUnlink,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)
	const actionsAddKioskItems = bindActionCreators(initKioskCreationAddItemsActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())
	let history = useHistory()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const [isEditable, setIsEditable] = useState(false)
	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modal
	const [showErrorUnlinkModal, setShowErrorUnlinkModal] = useState(false)
	const [textModal, setTextModal] = useState('')

	const match = useRouteMatch()

	const location = useLocation()

	// Columns
	const [columns, setColumns] = useState([])
	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}
	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleRedirect = () => {
		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[32])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)

		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
	}
	const handleViewItems = (row) => {
		history.push(`${uriList.distributionItem}${uriList.distributionGroupRepositorytDetail}/${row.itemId}`)
	}

	const handleAddItemCatalog = (row) => {
		actionsAddKioskItems.putKioskLinkItems(match.params.id, row.itemId)
	}

	const handleRmvItemCatalog = (row) => {
		if (row.canUnlink) {
			actionsAddKioskItems.putKioskUnlinkItems(match.params.id, row.itemDistributorId)
		}
	}

	const handlePagingDistribution = (paging) => {
		setPaging(paging)
		actionsAddKioskItems.postKioskCreationItems(handleFilterSend(), match.params.id, paging)
	}

	const handleFollowingStep = (_e) => {
		const pathName = location.pathname
		actionsAddKioskItems.getKioskItemsValidate(match.params.id, pathName.indexOf(uriList.initKioskCustomerManager) === -1 ? '' : 'customer')
	}
	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)

		if (isUndefined(pg)) {
			pg = { page: '0', size: '250' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsAddKioskItems.postKioskCreationItems(handleFilterSend(), match.params.id, pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
		}
	}

	const handleModalErrorUnlink = () => {
		setShowErrorUnlinkModal(false)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////
	useEffect(() => {
		if (!isUndefined(initKioskCreationStatus)) {
			setColumns([
				{
					columnReferential: 'kioskInCreationItem_distributorGrp',
					dataHook: 'labelDistributionGroup',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_distributionGroup'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationItem_productImage',
					dataHook: 'itemPicture',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemPicture'],
					sortable: true,
					isAuthorize: true,
					component: KioskAddItemImg,
					useCustomSkeleton: true,
				},
				{
					columnReferential: 'kioskInCreationItem_itemName',
					dataHook: 'labelItem',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemName'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationItem_state',
					dataHook: 'itemDistributorPresent',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemState'],
					sortable: true,
					isAuthorize: true,
					component: KioskAddItemStatus,
					useCustomSkeleton: true,
				},
				{
					columnReferential: 'kioskInCreationItem_availableDate',
					dataHook: 'availabiltyDate',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_availabilityDate'],
					sortable: true,
					isAuthorize: true,
					component: (props) => (props.row.availabiltyDate === null ? '-' : moment(props.row.availabiltyDate).format('DD/MM/YYYY HH:mm')),
				},
				{
					columnReferential: 'kioskInCreationItem_family',
					dataHook: 'itemFamily.translationKey',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemFamily'],
					sortable: true,
					isAuthorize: true,
					toTranslate: true,
				},
				{
					columnReferential: 'kioskInCreationItem_brand',
					dataHook: 'itemBrand.label',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemBrand'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationItem_Type',
					dataHook: 'itemType.translationKey',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemType'],
					toTranslate: true,
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationItem_consignation',
					dataHook: 'withConsignment.translationKey',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_consignationEnable'],
					sortable: true,
					isAuthorize: true,
					toTranslate: true,
				},
				{
					columnReferential: 'kioskInCreationItem_addDate',
					dataHook: 'addingDate',
					headerName: translations['page__itemCatalog__distributor__link__tableHeader_addDate'],
					sortable: true,
					isAuthorize: true,
					component: (props) => (props.row.addingDate === null ? '-' : moment(props.row.addingDate).format('DD/MM/YYYY HH:mm')),
				},

				{
					action: true,
					isFixed: true,
					component: ActionsTable,
					withIcons: true,
					hasActionIconsDisplay: true, //to set width on cells action, remove it when we refact action ActionPaper component
					rest: {
						tooltipPart: 'catalog',
						paperActionsList: [
							{
								isVisible: () => initKioskCreationStatus?.editable,
								translationKey: 'tooltip__admin__itemCatalog__distributor_showItem',
								clickAction: (row) => {
									handleViewItems(row)
								},
								iconDef: view,
							},
							{
								isVisible: (row) => initKioskCreationStatus?.statusId < 13 && row.canLink && initKioskCreationStatus?.editable,
								translationKey: 'tooltip__admin__itemCatalog__distributor_addItem',
								clickAction: (row) => {
									handleAddItemCatalog(row)
								},
								icon: Add,
								bgColor: Theme.colors.primary,
								hover: Theme.colors.wedealBlueOther,
							},
							{
								translationKey: 'tooltip__admin__itemCatalog__distributor_removeItem',
								clickAction: (row) => {
									handleRmvItemCatalog(row)
								},
								isVisible: (row) => initKioskCreationStatus?.statusId < 13 && row.canUnlink && initKioskCreationStatus?.editable,
								icon: Less,
								bgColor: Theme.colors.error,
								hover: Theme.colors.wedealRedOther,
							},
						],
					},
				},
			])
		}
	}, [translations, initKioskCreationStatus])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 25,
		labelPageTable: 'kioskInCreationItem',
	}

	const [configTableTitle, setConfigTableTitle] = useState({ actions: {}, paging: { fnSendTo: (paging) => handlePagingDistribution(paging) } })
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(initKioskCreationItems) && !isUndefined(initKioskCreationItems)) {
			cfg.paging = {
				totalElements: !isUndefined(initKioskCreationItems.data?.headerContent?.contentPagined?.totalElements),
				totalPages: !isUndefined(initKioskCreationItems.data?.headerContent?.contentPagined?.totalPages),
				fnSendTo: (paging) => handlePagingDistribution(paging),
			}
		}
		setConfigTableTitle(cfg)

		// Disable fields if we are coming from "View" action, or by charging request with URL address
		if (!isUndefined(initKioskCreationItems.data?.headerParam)) {
			let editable = true
			if (initKioskCreation.forceReadOnly) {
				editable = false
			} else {
				editable = initKioskCreationItems.data?.headerParam?.progressInfo.editable
			}
			setIsEditable(editable)
		}
	}, [initKioskCreationItems, initKioskCreation])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters?.searchField !== searchValue || searchValue === initKioskCreation) return
		handleSubmit()
	}, [filters?.searchField])

	useEffect(() => {
		const filtersCp = cloneDeep(initKioskCreationFilters)
		if (!isUndefined(filtersCp)) {
			filtersCp.withFilters = true
		}
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [initKioskCreationFilters])
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = [
			<TooltipHelp content={'tooltip__admin__itemCatalog__distributor_page'} childrenPos={1}>
				{translations['page__initKiosk__kioskCreation_items_title']}
			</TooltipHelp>,
		]

		cfg.paging = {
			totalElements: initKioskCreationItems.data?.headerContent?.contentPagined?.totalElements,
			totalPages: initKioskCreationItems.data?.headerContent?.contentPagined?.totalPages,
			fnSendTo: (paging) => handlePagingDistribution(paging),
		}

		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
			followingStep: {
				id: 'continue',
				type: 'submit',
				imgLeftMgin: '11px',
				imgMgin: '11px',
				img: ArrowWhiteRight,
				bgColor: Theme.colors.validation,
				height: 32,
				width: 208,
				text: translations['page__initKiosk__common__action_nextStep'],
				actionHandler: handleFollowingStep,
				step: initKioskCreationStatus?.statusId >= 6 ? true : false,
				disabled: !isEditable,
			},
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_brandLabel']}
					data={filters?.filtersSelection?.itemBrand.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemBrand'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemType']}
					data={filters?.filtersSelection?.itemType.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemType'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemFamily']}
					data={filters?.filtersSelection?.itemFamily.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemFamily'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemState']}
					data={filters?.filtersSelection?.itemState.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemState'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_distributoinGroup']}
					data={filters?.filtersSelection?.distributionGroup.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'distributionGroup'}
				/>
			),
		]

		cfg.usingRafters = true

		setConfigTableTitle(cfg)
	}, [translations, filters, isEditable, initKioskCreationStatus, initKioskCreationItems, initKioskCreation])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				searchFieldUpdated: false,
			}
			actionsAddKioskItems.postKioskCreationItems(filtersCp, match.params.id)
			actionsColumns.setColumns([])
			setFilters(filtersCp)
		}
	}, [translations])

	useEffect(() => {
		if (isUpdated) {
			actionsAddKioskItems.postKioskCreationItems(handleFilterSend(), match.params.id, paging)
		}
	}, [isUpdated])

	useEffect(() => {
		return function cleanUp() {
			actionsAddKioskItems.resetDataAddItems()

			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (!isEqual(errorUnlink, {})) {
			setShowErrorUnlinkModal(true)
			setTextModal(errorUnlink?.msgParameters[0])
		}
	}, [errorUnlink])
	// We transform text to display
	let article = `<span style="color: ${Theme.colors.primary}" > [${textModal}] </span>`
	let text = StringFormatter.ResponseMessageParser(
		replace(translations['common__message__itemCatalog__link__removeItem_error_stock'], '\\n', '<br>'),
		[article]
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={initKioskCreationContent}
				inputConfig={configTable}
				currentPaging={paging}
				tableReferential={tableReferential}
			/>
		)
	}, [initKioskCreationContent, columns, configTable, translations, paging])
	return (
		<>
			{/* MODAL ERROR CAN T UNLINK*/}
			{showErrorUnlinkModal && (
				<Modals
					title={translations['modal__itemCatalog__distributor__link__removeError_title']}
					closeModalHandler={handleModalErrorUnlink}
					showModal={showErrorUnlinkModal}
					//level={(row.canEnabled && row.isDisable) ? "" : "error"}
					icon={true}
				>
					<TextModal dangerouslySetInnerHTML={{ __html: text }}></TextModal>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleModalErrorUnlink}
							text={translations['common__text__ok']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapperCustom>
				</Modals>
			)}
			{/* TABLEAU */}

			<KioskAddItemWrapper>
				<PageWrapperLinksCustom rafterDisplayed={initKioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} isFollowingStep={true} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</KioskAddItemWrapper>
		</>
	)
}

KioskAddItem.propTypes = {}

KioskAddItem.defaultPropTypes = {}

export default KioskAddItem
